import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CouponsComponent } from './coupons.component';
import { CouponsResolve } from './coupons.resolve';

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: 'manage/admin/coupons',
        component: CouponsComponent,
        resolve: {
          portal: CouponsResolve,
        },
      },
    ]),
  ],
  exports: [RouterModule],
})
export class CouponsRoutingModule {}
